import { render, staticRenderFns } from "./exchange-goods-skeleton.vue?vue&type=template&id=7fae5b65&scoped=true&lang=pug&"
import script from "./exchange-goods-skeleton.vue?vue&type=script&lang=js&"
export * from "./exchange-goods-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./exchange-goods-skeleton.vue?vue&type=style&index=0&id=7fae5b65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fae5b65",
  null
  
)

export default component.exports